import { Flex }      from "@mantine/core";
import { useRouter } from "next/router";

import { LIVESESSION, VIDEO, formattedVideoDuration, shortenNumber } from "_common/utils";
import Image                                                         from "_components/atoms/image";
import LiveCount                                                     from "_components/atoms/liveCount";
import Typography                                                    from "_components/atoms/typography";
import ViewCount                                                     from "_components/atoms/viewCount";
import VideoDurationCount                                            from "_components/organisms/videoCardList/videoCard/videoDutaionCount";

import useStyles from "./styles";

const component = ( { data } ) => {
	const { classes } = useStyles ( {}, { name: "mobileVideoCard" } );

	const router = useRouter ();

	const onClickCard = () => {
		router.push ( `/${ data.feedType === "VIDEO" ? "video" : "stream" }/${ data.id }` );
	};

	return (
		<div className = { classes.mobileVideoCardContainer }
			onClick       = { onClickCard }
		>
			<div className = { classes.imageContainer }>
				<Image
					className = { classes.image }
					src       = { data.thumbnail }
				/>

				<div className = { classes.tagsContianer }>
					{data.feedType === LIVESESSION ? (
						<>
							{( data.isLive ? (
								<LiveCount
									containerClass = { classes.liveTag }
								/>
							) : null )}

							<ViewCount viewCount = { data?.views } />
						</>
					)

						: null}

					{data?.feedType === VIDEO ? (
						<VideoDurationCount
							containerClass = { classes.durationTag }
							viewCount      = { formattedVideoDuration ( data?.videoDuration ) }
						/>
					) : null}

				</div>

				<div className = { classes.backgroundOverlay } />

				<div className = { classes.cardInfoContainer }>
					<Image
						className = { classes?.profileImg }
						src       = { data.userData.photo }
					/>

					<div style = { { overflow: "hidden" } }>
						<Typography
							noWrap
							className = { `${ classes.videoTitle } colorWhite` }
							title     = { data?.title }
						/>

						<Flex align = { "center" }>

							<Typography
								className = { `${ classes.creatorName } colorWhite` }
								title     = { data?.userData?.name }
							/>

							{data.feedType === VIDEO ? (
								<>
									<div className = { classes.ellipse } />

									<Typography
										className = { `${ classes.creatorName } colorWhite` }
										title     = { `${ shortenNumber ( data?.views ) } Views` }
									/>
								</>
							)
								: null}
						</Flex>

					</div>
				</div>
			</div>
		</div>
	);
};

export default component;